module.exports = __webpack_public_path__ + "static/img/Michael-Hurley.f5c0342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael-Hurley.jpg
// module id = 3yu/
// module chunks = 0